const apiUrl = process.env.REACT_APP_API_URL;

export const GetSprintsByProject = async (idProjecte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${idProjecte}/sprints`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los sprints:', error);
        return [];
    }
};
